import { listaSituacao } from './../shared/listas-parametros';
import { element } from 'protractor';
import { RequestOptions } from '@angular/http';
import { AssinantesService } from './../assinantes/assinantes.service';
import { AssinantePF, AssinantePJ } from './assinante.model';
import { PessoaEndereco } from './../pessoa/pessoa.model';
import { Component, OnInit, ViewChild  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { EnderecoLocalTipo } from '../endereco-local-tipo/endereco-local-tipo.model';
import { EnderecoLocalTipoService } from '../endereco-local-tipo/endereco-local-tipo.service';
import { LogradouroCep } from '../logradouro-cep/logradouro-cep.model';
import { LogradouroCepService } from '../logradouro-cep/logradouro-cep.service';
import { Bairro } from '../bairro/bairro.model';
import { BairroService } from '../bairro/bairro.service';
import { listaEstadoCivil, listaSexo, listaSimNao } from '../shared/listas-parametros';
import notify from 'devextreme/ui/notify';
import { Mascaras, formataCEP, formataCEPTxt } from './../app.config';

@Component({
  selector: 'ntc-assinante',
  templateUrl: './assinante.component.html',
  styleUrls: ['./assinante.component.css']
})
export class AssinanteComponent implements OnInit {

  loadingVisible = false;

  listasForm = [
    {Nome: 'listaBairro', status: false},
    {Nome: 'listaEnderecoLocalTipo', status: false},
    {Nome: 'listaEstadoCivil', status: true},
    {Nome: 'listaLogradouroCEP', status: false},
    {Nome: 'listaSexo', status: true},
    {Nome: 'listaSimNao', status: true},
    {Nome: 'listaSituacao', status: true}
  ];

  assinantePF: AssinantePF;
  assinantePJ: AssinantePJ;

  listaSituacao = listaSituacao;

  listaBairro: Bairro[];
  listaEnderecoLocalTipo: EnderecoLocalTipo[];
  listaLogradouroCEP: LogradouroCep[];

  listaEstadoCivil = listaEstadoCivil;
  listaSexo = listaSexo;
  listaSimNao = listaSimNao;

  tipoPessoa = [' - ', 'Física', 'Jurídica'];

  listaEnderecoTipo = [
    {Id: 'I', Descricao: 'Instalação'},
    {Id: 'C', Descricao: 'Cobrança'}
  ];

  sTipoPessoa: string;

  colunasGridEnderecoPessoa = null;
  editOptionsGridEnderecoPessoa = null;
  itemsForm = null;
  itemsFormPF = null;
  itemsFormPJ = null;

  assinanteForm = null;

  constructor(
    private assinantesService: AssinantesService,
    private enderecoLocalTipoService: EnderecoLocalTipoService,
    private bairroService: BairroService,
    private logradouroCepService: LogradouroCepService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.loadingVisible = true;
    this.assinantePF = new AssinantePF;
    this.assinantePJ = new AssinantePJ;

    //this.colunasGridEnderecoPessoa = [];

    this.editOptionsGridEnderecoPessoa = {
      mode: 'popup', //form
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Pessoa Endereços',
        showTitle: true
      }
    };

    this.itemsForm = [];

    this.itemsFormPJ = [
      {
        itemType: 'group',
        caption: 'Dados Pessoa',
        items: [
          {
            dataField: 'Id',
            editorType: 'dxTextBox',
            editorOptions: { disabled: true }
          },
          {
            dataField: 'Pessoa.Nome',
            editorType: 'dxTextBox',
            label: { text: 'Nome Fantasia' },
            editorOptions: {},
            validationRules: [{
              type: 'required',
              message: 'Nome Fantasia é obrigatório.'
            }]
          },
          {
            dataField: 'Pessoa.RazaoSocial',
            editorType: 'dxTextBox',
            label: { text: 'Razão Social' },
            editorOptions: {},
            validationRules: [{
              type: 'required',
              message: 'Razão Social é obrigatório.'
            }]
          },
          {
            dataField: 'Pessoa.InscEstadual',
            editorType: 'dxTextBox',
            label: { text: 'Inscrição Estadual' },
            editorOptions: {}
          },
          {
            dataField: 'Pessoa.Cnpj',
            editorType: 'dxTextBox',
            label: { text: 'CNPJ' },
            editorOptions: {
              mask: Mascaras.Cnpj
            },
            validationRules: [{
              type: 'required',
              message: 'CNPJ é obrigatório.'
            }]
          },
          {
            dataField: 'Pessoa.DtCadastro',
            editorType: 'dxDateBox',
            label: { text: 'Data de cadastro' },
            editorOptions: { width: '100%', disabled: true }
          },
          {
            dataField: 'Pessoa.DtAlteracao',
            editorType: 'dxDateBox',
            label: { text: 'Data última alteração' },
            editorOptions: { width: '100%', disabled: true }
          }
        ]
      },
      {
        itemType: 'group',
        caption: 'Dados Assinante',
        items: [
          /*
          {
            dataField: 'Id',
            editorType: 'dxTextBox',
            editorOptions: { disabled: true }
          },
          */
          {
            dataField: 'AssinanteEstado',
            editorType: 'dxSelectBox',
            label: { text: 'Estado (Situação)' },
            editorOptions: { items: this.listaSituacao, displayExpr: 'Descricao', valueExpr: 'Id' },
            validationRules: [{
              type: 'required',
              message: 'Estado do assinante é obrigatório.'
            }]
          },
          {
            dataField: 'Observacoes',
            label: { text: 'Observações' },
            editorType: 'dxTextArea',
            editorOptions: { height: 90 },
            colSpan: '2'
          }
        ]
      }
    ];

    this.itemsFormPF = [
      {
        itemType: 'group',
        caption: 'Dados Pessoa',
        items: [
          {
            dataField: 'Pessoa.Nome',
            editorType: 'dxTextBox',
            label: { text: 'Nome' },
            editorOptions: {},
            validationRules: [{
              type: 'required',
              message: 'Nome é obrigatório.'
            }]
          },
          {
            dataField: 'Pessoa.Rg',
            editorType: 'dxTextBox',
            label: { text: 'Rg' },
            editorOptions: {}
          },
          {
            dataField: 'Pessoa.Cpf',
            editorType: 'dxTextBox',
            label: { text: 'CPF' },
            editorOptions: {
              mask: Mascaras.Cpf
            },
            validationRules: [{
              type: 'required',
              message: 'CPF é obrigatório.'
            }]
          },
          {
            dataField: 'Pessoa.DtNascimento',
            editorType: 'dxDateBox',
            label: { text: 'Data de nascimento' },
            editorOptions: { width: '100%' }
          },
          {
            dataField: 'Pessoa.DtCadastro',
            editorType: 'dxDateBox',
            label: { text: 'Data de cadastro' },
            editorOptions: { width: '100%', disabled: true }
          },
          {
            dataField: 'Pessoa.DtAlteracao',
            editorType: 'dxDateBox',
            label: { text: 'Data última alteração' },
            editorOptions: { width: '100%', disabled: true }
          },
          {
            dataField: 'Pessoa.EstadoCivil',
            editorType: 'dxSelectBox',
            label: { text: 'Estado Civil' },
            editorOptions: { items: this.listaEstadoCivil, displayExpr: 'Descricao', valueExpr: 'Id' }
          },
          {
            dataField: 'Pessoa.Sexo',
            editorType: 'dxSelectBox',
            label: { text: 'Sexo' },
            editorOptions: { items: this.listaSexo, displayExpr: 'Descricao', valueExpr: 'Id' }
          },
          {
            dataField: 'Pessoa.Emancipado',
            editorType: 'dxSelectBox',
            label: { text: 'Emancipado' },
            editorOptions: { items: this.listaSimNao, displayExpr: 'Descricao', valueExpr: 'Id' }
          }
        ]
      },
      {
        itemType: 'group',
        caption: 'Dados Assinante',
        items: [
          {
            dataField: 'Id',
            editorType: 'dxTextBox',
            editorOptions: { disabled: true }
          },
          {
            dataField: 'AssinanteEstado',
            editorType: 'dxSelectBox',
            label: { text: 'Estado (Situação)' },
            editorOptions: { items: this.listaSituacao, displayExpr: 'Descricao', valueExpr: 'Id' },
            validationRules: [{
              type: 'required',
              message: 'Estado do assinante é obrigatório.'
            }]
          },
          {
            dataField: 'Observacoes',
            label: { text: 'Observações' },
            editorType: 'dxTextArea',
            editorOptions: { height: 90 },
            colSpan: '2'
          },
          {
            dataField: 'NomeEmpresaTrabalho',
            editorType: 'dxTextBox',
            label: { text: 'Nome Empresa - Trabalho' }
          },
          {
            dataField: 'RendaFamiliar',
            editorType: 'dxNumberBox',
            label: { text: 'Renda Familiar' },
            format: 'currency',
            editorOptions: { format: 'R$ #,##0.00' }
          }
        ]
      }
    ];

    // carrega a lista de Bairro
    this.bairroService.getBairros()
      .subscribe(bairros => {
        this.listaBairro = bairros;
        this.verificarListasCarregadas('listaBairro');
      },
      error => {
        this.verificarListasCarregadas('listaBairro');
      }
    );
    // carrega a lista de LogradouroCep
    this.logradouroCepService.getLogradouroCeps()
      .subscribe(logradourosCep => {
        this.listaLogradouroCEP = logradourosCep;
        this.verificarListasCarregadas('listaLogradouroCEP');
      },
      error => {
        this.verificarListasCarregadas('listaLogradouroCEP');
      }
    );
    // carrega a lista de EnderecoLocalTipo e adiciona na grid de EnderecoPessoa
    this.enderecoLocalTipoService.getEnderecoLocalTipo()
      .subscribe(enderecosLocalTipo => {
        this.listaEnderecoLocalTipo = enderecosLocalTipo;
        this.verificarListasCarregadas('listaEnderecoLocalTipo');
      },
      error => {
        this.verificarListasCarregadas('listaEnderecoLocalTipo');
      }
      );


    if (this.route.snapshot.params['id'] !== undefined) {
      // Precisa criar uma posição no array para a dx-grid não dar 'bug' (de não salvar dentro do datasource)
      //this.assinantePF.Pessoa.PessoaEnderecos[0] = new PessoaEndereco;
      //this.assinantesService.getAssinantePFById(this.route.snapshot.params['id'])
      this.assinantesService.getAssinanteById(this.route.snapshot.params['id'])
        .subscribe(assinante => {
          const aux = assinante;

          if (aux.Pessoa.hasOwnProperty('Cpf')) {
            this.assinantePF = assinante;
            this.sTipoPessoa = 'Física';
          } else {
            this.assinantePJ = assinante;
            this.sTipoPessoa = 'Jurídica';
          }

          this.carregaTipoPessoa(this.sTipoPessoa);

        });
    }
  }

  ngOnInit() {
    console.log(this.assinanteForm);
    /*
    if (this.route.snapshot.params['id'] !== undefined) {
      this.assinantesService.getAssinantePFById(this.route.snapshot.params['id'])
        .subscribe(assinante => this.assinantePF = assinante);
    }
    */
  }

  gravar = function(params: any) {
    const result = params.validationGroup.validate();

    if (result.isValid) {
      //console.log(this.assinanteForm);

      if ( this.sTipoPessoa === 'Física' ) {
        this.assinantePF = this.assinanteForm;
        this.assinantesService.gravarAssinantePF(this.assinantePF)
        .subscribe((ret: AssinantePF) => {
          //console.log(`Assinante gravado com sucesso! ${ret.Id}`);
          notify(`Assinante gravado com sucesso! ${ret.Id}`, 'success', 2000);
          this.router.navigate(['/assinantes']);
        },
        error => {
          notify('Erro ao gravar Assinante!', 'error', 2000);
        });

      } else if ( this.sTipoPessoa === 'Jurídica' ) {
        this.assinantePJ = this.assinanteForm;
        this.assinantesService.gravarAssinantePJ(this.assinantePJ)
        .subscribe((ret: AssinantePJ) => {
          //console.log(`Assinante gravado com sucesso! ${ret.Id}`);
          notify(`Assinante gravado com sucesso! ${ret.Id}`, 'success', 2000);
          this.router.navigate(['/assinantes']);
        },
        error => {
          notify('Erro ao gravar Assinante!', 'error', 2000);
        });
      }
    } else {
      notify('Cadastro Inválido!', 'error', 2000);
    }

    //this.isPopupVisible = !this.isPopupVisible;
  };

  changeTipoPessoa = function(e){
    this.carregaTipoPessoa(e.value);
  };

  carregaTipoPessoa = function(sTipo){
    this.assinanteForm = null;
    this.itemsForm = null;
    let gridEndereco;

    if ( sTipo === 'Física') {
      this.itemsForm = this.itemsFormPF;
      this.assinanteForm = new AssinantePF;
      this.assinanteForm = this.assinantePF;

      // Criando a grid de endereço no retorno do service, para não perder vinculo do bind,
      // se criar fora e atribuir novo valor ele da "bug"
      // bug = o componente da grid cria um dataSource na memória e não utiliza o dataSouce informado
      gridEndereco = {
        itemType: 'group',
        caption: 'Pessoa Endereços',
        items: [
          {
            editorType: 'dxDataGrid',
            editorOptions: {
              dataSource: this.assinantePF.Pessoa.PessoaEnderecos,
              columns: this.colunasGridEnderecoPessoa,
              editing: this.editOptionsGridEnderecoPessoa
            }
          }
        ]
      };
    } else if (sTipo === 'Jurídica') {
      this.itemsForm = this.itemsFormPJ;
      this.assinanteForm = new AssinantePJ;
      this.assinanteForm = this.assinantePJ;

      // Criando a grid de endereço no retorno do service, para não perder vinculo do bind,
      // se criar fora e atribuir novo valor ele da "bug"
      // bug = o componente da grid cria um dataSource na memória e não utiliza o dataSouce informado
      gridEndereco = {
        itemType: 'group',
        caption: 'Pessoa Endereços',
        items: [
          {
            editorType: 'dxDataGrid',
            editorOptions: {
              dataSource: this.assinantePJ.Pessoa.PessoaEnderecos,
              columns: this.colunasGridEnderecoPessoa,
              editing: this.editOptionsGridEnderecoPessoa
            }
          }
        ]
      };
    }

    // Verifica se a grid de endereço já foi adicionado no form
    const foundItem = this.itemsForm.find((fItem) => fItem.caption === 'Pessoa Endereços');

    if (foundItem) {
      // Adicinando grid de endereço no form
      this.itemsForm.splice(this.itemsForm.indexOf(foundItem), 1);
      this.itemsForm.push(gridEndereco);
    } else {
      // Adicinando grid de endereço no form
      this.itemsForm.push(gridEndereco);
    }
  };

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    if (nomeLista !== '') {
      const foundItem = this.listasForm.find((fItem) => fItem.Nome === nomeLista);

      if (foundItem) {
        foundItem.status = true;
      }
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if ( (this.listasForm[0].status === true) &&
         (this.listasForm[1].status === true) &&
         (this.listasForm[2].status === true) &&
         (this.listasForm[3].status === true) &&
         (this.listasForm[4].status === true) &&
         (this.listasForm[5].status === true) &&
         (this.listasForm[6].status === true) ) {

      this.montaForm();

      return true;
    } else {
      return false;
    }
  }

  montaForm() {
    this.colunasGridEnderecoPessoa = [
      {
        dataField: 'Complemento',
        dataType: 'string'
      },
      {
        dataField: 'Bairro.Id',
        caption: 'Bairro',
        width: 125,
        lookup: {
            dataSource: this.listaBairro,
            displayExpr: 'NomeBairro',
            valueExpr: 'Id'
        }
      },
      {
        dataField: 'EnderecoLocalTipo.Id',
        caption: 'Tipo Local',
        width: 125,
        lookup: {
            dataSource: this.listaEnderecoLocalTipo,
            displayExpr: 'DescricaoEnderecoLocalTipo',
            valueExpr: 'Id'
        }
      },
      {
        dataField: 'LogradouroCEP.Id',
        caption: 'CEP',
        width: 125,
        lookup: {
            dataSource: this.listaLogradouroCEP,
            displayExpr: this.formataCEPLookup,
            valueExpr: 'Id'
        },
        customizeText: formataCEP
      },
      {
        dataField: 'NumeroEndereco',
        dataType: 'string'
      },
      {
        dataField: 'EnderecoTipo',
        caption: 'Tipo de Endereço',
        width: 125,
        lookup: {
            dataSource: this.listaEnderecoTipo,
            displayExpr: 'Descricao',
            valueExpr: 'Id'
        }
      },
    ];

    this.loadingVisible = false;
  }

  formataCEPLookup = function(row) {
    return formataCEPTxt(row.CEP);
  };

}



// WEBPACK FOOTER //
// ./src/app/assinante/assinante.component.ts